/**
 * Brand and Brand Category Model Interfaces
 * Framework-agnostic TypeScript interfaces
 */

export interface BrandCategory {
  id?: number;
  brand_category_id?: number;
  brand_category_name: string;
  brand_category?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface Brand {
  brand_id?: number;
  id?: number;
  brand_name: string;
  brand?: string;
  brand_category_id: number;
  brand_category_name?: string;
  brand_category?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface BrandCategoryFormData {
  id?: number;
  brand_category_id?: number;
  brand_category_name: string;
}

export interface BrandFormData {
  id?: number;
  brand_id?: number;
  brand_name: string;
  brand_category_id: number;
}

export interface BrandCategoryApiResponse {
  data: {
    brand_categories: BrandCategory[];
  };
  message?: string;
  success?: boolean;
}

export interface BrandApiResponse {
  data: {
    brands: Brand[];
  };
  message?: string;
  success?: boolean;
}
